import type { IconData } from '@stacksjs/iconify-core'

export const creativeCommons: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#fff\" d=\"M24 3a21 21 0 1 0 0 42a21 21 0 1 0 0-42\"/><path fill=\"#8fbffa\" d=\"M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8S8 15.163 8 24s7.163 16 16 16\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M24 3a21 21 0 1 0 0 42a21 21 0 1 0 0-42\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M24 8a16 16 0 1 0 0 32a16 16 0 1 0 0-32\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M22 19.682c-1.712-1.079-8-1.626-8 4.318s6.288 5.397 8 4.317m12-8.635c-1.712-1.079-8-1.626-8 4.318s6.288 5.397 8 4.317\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default creativeCommons
